var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LlQuestionNumberList',{attrs:{"text":"建議題目僅供參考，詳應依單位內實務訂定稽核標準","is-mt-lg":"","text-icon":"icon-warning","only-number":"","total-number":9999}})
}
var staticRenderFns = []

export { render, staticRenderFns }